import { ReactNode } from 'react'
import { ArrowLeftIcon } from '@radix-ui/react-icons'
import Link from 'next/link'

export const Back = ({ href, children }: { href: string; children: ReactNode }) => {
  return (
    <Link href={href} className={'flex items-center gap-3 mb-6 hover:opacity-60 transition duration-200'}>
      <ArrowLeftIcon width={20} height={20} />
      {children}
    </Link>
  )
}
